// @flow
import { KEY } from './constants'

export const getModal = (state: Object) => state[KEY].modal
